module.exports = __webpack_public_path__ + "img/7.417bde39.jpeg";